// import { lazy, Suspense } from "react";
// import { Router, Switch, Route } from "react-router-dom";
// // import { MemoryRouter as Router, Switch, Route } from "react-router-dom";
// import routes from "./config";
// import { Styles } from "../styles/styles";
// import React from "react";

// const RouterComponent = () => {
//     {
//         let previousStep = sessionStorage.getItem("previousStep") as string;
//         let previousPath = sessionStorage.getItem("previousPath") as string;
        
//     }
//     return (
//         <Router>
//             <Suspense fallback={null}>
//                 <Styles />
//                 <Switch>
//                     {routes.map((routeItem) => {
//                         return (
//                             <Route
//                                 key={routeItem.component}
//                                 path={routeItem.path}
//                                 exact={routeItem.exact}
//                                 component={lazy(() => import(`../pages/${routeItem.component}`))}
//                             />
//                         );
//                     })}
//                 </Switch>
//             </Suspense>
//         </Router>
//     );
// };

// export default RouterComponent;


import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import routes from "./config";
import { Styles } from "../styles/styles";
import React from "react";
import ErrorBoundary from "../common/ErrorBoundary";

const Router = () => {
  return (
    <ErrorBoundary>
    <Suspense fallback={null}>
      <Styles />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
    </Suspense>
    </ErrorBoundary>
  );
};

export default Router;